import { Expose, Type } from 'class-transformer';
import { Positionable } from 'src/app/map/model/positionable';
import { Nameable } from 'src/app/common/model/nameable';
import * as L from 'leaflet';
import { ValueField } from 'src/app/settings/model/value-field';
import { FieldType } from 'src/app/settings/model/field-type';
import { Carrier } from 'src/app/management/model/carrier';
import { Stop } from './vehicle-stops';

export const SP_CODE = 'sp_code';
export const SP_NAME = 'sp_name';

export class StopPile implements Positionable, Nameable {
  @Expose({ name: 'sp_id' })
  id: number;
  @Expose({ name: 'sp_latitude' })
  latitude: number;
  @Expose({ name: 'sp_longitude' })
  longitude: number;
  @Expose({ name: SP_CODE })
  code: string;
  @Expose({ name: SP_NAME })
  name: string;
  @Expose({ name: 'sp_description' })
  description: string;
  @Expose({ name: 'sp_carrier' })
  @Type(() => Carrier)
  carrier?: Carrier;
  // Numer przystanku na trasie pojazdu (1 = pierwszy), liczony po stronie klienta (VehicleStopsService),
  // stąd brak @Expose. Przystanek spoza trasy numeru nie dostaje.
  routeSequence?: number;

  static getName(): string {
    return 'STOP_PILE';
  }

  static createFromStop(stop: Stop): StopPile {
    const stopPile = new StopPile();
    stopPile.id = stop.id;
    stopPile.latitude = stop.latitude;
    stopPile.longitude = stop.longitude;
    stopPile.code = stop.code;
    stopPile.name = stop.name;
    stopPile.description = stop.description;
    return stopPile;
  }

  getClassName(): string {
    return 'StopPile';
  }

  getPosition(): L.LatLng {
    return L.latLng(this.latitude, this.longitude);
  }
}

// Przystanki leżą w całości w pamięci, więc lista wartości w filtrze kolumnowym pokrywa cały zbiór.
export const stopPileFields: ValueField[] = [
  Object.assign(new ValueField(), {
    name: 'name',
    type: FieldType.TEXT,
    visible: true,
    canFilter: true,
    filterOptionsFromData: true
  }),
  Object.assign(new ValueField(), {
    name: 'description',
    type: FieldType.TEXT,
    visible: true,
    canFilter: true,
    filterOptionsFromData: true,
    filterEmptyOptionLabel: 'column-filter.no-values'
  }),
  Object.assign(new ValueField(), {
    name: 'code',
    type: FieldType.TEXT,
    visible: true,
    canFilter: true,
    filterOptionsFromData: true
  }),
  Object.assign(new ValueField(), {
    name: 'id',
    type: FieldType.INTEGER,
    primaryKey: true,
    visible: false,
    canFilter: false
  }),
  Object.assign(new ValueField(), {
    name: 'latitude',
    type: FieldType.FLOAT,
    visible: true,
    canFilter: true
  }),
  Object.assign(new ValueField(), {
    name: 'longitude',
    type: FieldType.FLOAT,
    visible: true,
    canFilter: true
  }),
  Object.assign(new ValueField(), {
    name: 'carrierName',
    type: FieldType.TEXT,
    visible: true,
    canFilter: false,
    jsonpath: '$.carrier.name',
    filterOptionsFromData: true,
    filterEmptyOptionLabel: 'column-filter.no-values'
  })
];
